import { render, staticRenderFns } from "./application-standalone.vue?vue&type=template&id=7ffb3a9c&scoped=true"
import script from "./application-standalone.vue?vue&type=script&lang=ts"
export * from "./application-standalone.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffb3a9c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ffb3a9c')) {
      api.createRecord('7ffb3a9c', component.options)
    } else {
      api.reload('7ffb3a9c', component.options)
    }
    module.hot.accept("./application-standalone.vue?vue&type=template&id=7ffb3a9c&scoped=true", function () {
      api.rerender('7ffb3a9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/client-portal/js/modules/application-standalone/components/application-standalone.vue"
export default component.exports